import {Component, EventEmitter, Output} from '@angular/core';
import {BaseComponent} from "../../BaseComponent";
import {ValueChangedEvent} from "devextreme/ui/text_box";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent extends BaseComponent {

  /**
   * Event that tells the father component to destroy this component
   */
  @Output('closeDialog') closeDialog = new EventEmitter();
  /**
   * When true deactivates the form until creation process is completed to avoid duplication for fast clicks
   * @protected
   */
  createRequestSent: boolean;
  /**
   * Object containing the mail address of the user trying to reset password
   * @protected
   */
  protected email!: string;
  /**
   * Boolean flag used to store the validity of the form
   * @protected
   */
  protected isNewFormValid: boolean;

  constructor() {
    super();
    this.createRequestSent = false;
    this.isNewFormValid = false;
  }

  validateEmail($event: ValueChangedEvent) {
    if (!!$event.value) {
      if (!this.appService.EMAIL_REGEX.test($event.value)) {
        this.isNewFormValid = false;
        $event.component.option("isValid", false);
      } else {
        this.isNewFormValid = true;
        $event.component.option("isValid", true);
      }
    }
  }

  checkValidationAndSave() {
    if (this.isNewFormValid) {
      this.createRequestSent = true;
      this.closeDialog.emit(this.email);
    }
  }
}
